<app-referral-selection (closeNewReferralType)="newReferralTypeDialogOpen = false"
    (selectedNewReferralType)="onSelectNewReferralType($event)" [dialogOpened]="newReferralTypeDialogOpen">
</app-referral-selection>

<app-referral-add [memberId]="memberId" [serviceCategories]="serviceCategories" [excludedServices]="excludedServices"
    [referralReassign]="referralReassign" (closeNewReferral)="closeNewReferral($event)"
    (sendReferrals)="onSendReferrals($event)" [dialogOpened]="newReferralDialogOpen">
</app-referral-add>